import { Routes } from '@/config/routes';
import { PaymentGateway } from '@/types';

export const siteSettings = {
  name: 'Qualidoc',
  description: '',
  logo: {
    url: '/logo.svg',
    alt: 'Qualidoc',
    href: '/grocery',
    width: 128,
    height: 40,
  },
  defaultLanguage: 'en',
  currencyCode: 'BRL',
  product: {
    placeholderImage: '/product-placeholder.svg',
    cardMaps: {
      grocery: 'Krypton',
      furniture: 'Radon',
      bag: 'Oganesson',
      makeup: 'Neon',
      book: 'Xenon',
      medicine: 'Helium',
      default: 'Argon',
    },
  },
  authorizedLinks: [
    { href: Routes.profile, label: 'auth-menu-profile' },
    {
      href: Routes.changePassword,
      label: 'profile-sidebar-password',
    },
    { href: Routes.cards, label: 'profile-sidebar-my-cards' },
    { href: Routes.orders, label: 'auth-menu-my-orders' },
    {
      href: Routes.addresses,
      label: 'profile-sidebar-addresses',
    },
    { href: Routes.wishlists, label: 'profile-sidebar-my-wishlist' },
  ],
  // TODO: avaliate when to return some routes
  authorizedLinksMobile: [
    { 
      href: Routes.profile, 
      label: 'auth-menu-profile',
      icon: 'ProfileIcon',
    },
    {
      href: Routes.friendsIndication,
      label: 'profile-sidebar-friends-indication',
      icon: 'IndiqueAmigosIcon',
    },
    { 
      href: Routes.changePassword, 
      label: 'profile-sidebar-password',
      icon: 'ResetPasswordIcon',
    },
    { 
      href: Routes.cards, 
      label: 'profile-sidebar-my-cards',
      icon: 'CardsIcon',
    },
    { 
      href: Routes.orders, 
      label: 'auth-menu-my-orders',
      icon: 'OrdersIcon',
    },
    {
      href: Routes.addresses,
      label: 'profile-sidebar-addresses',
      icon: 'LocationIcon',
    },
    { 
      href: Routes.wishlists, 
      label: 'profile-sidebar-my-wishlist',
      icon: 'FavoritesIcon',
    },
  ],
  dashboardSidebarMenu: [
    {
      href: Routes.profile,
      label: 'profile-sidebar-profile',
      icon: 'ProfileIcon',
    },
    {
      href: Routes.friendsIndication,
      label: 'profile-sidebar-friends-indication',
      icon: 'IndiqueAmigosIcon',
    },
    {
      href: Routes.changePassword,
      label: 'profile-sidebar-password',
      icon: 'ResetPasswordIcon',
    },
    {
      href: Routes.cards,
      label: 'profile-sidebar-my-cards',
      icon: 'CardsIcon',
      // MultiPayment: Make it dynamic or from mapper
      cardsPayment: [PaymentGateway.STRIPE],
    },
    {
      href: Routes.orders,
      label: 'profile-sidebar-orders',
      icon: 'OrdersIcon',
    },
    {
      href: Routes.addresses,
      label: 'profile-sidebar-addresses',
      icon: 'LocationIcon',
    },
    { 
      href: Routes.wishlists, 
      label: 'profile-sidebar-my-wishlist',
      icon: 'FavoritesIcon',
    },
    // {
    //   href: Routes.refunds,
    //   label: 'text-my-refunds',
    // },
    // {
    //   href: Routes.help,
    //   label: 'profile-sidebar-help',
    // },
    {
      href: Routes.logout,
      label: 'profile-sidebar-logout',
    },
  ],
  sellingAdvertisement: {
    image: {
      src: '/selling.png',
      alt: 'Selling Advertisement',
    },
  },
  cta: {
    mockup_img_src: '/mockup-img.png',
    play_store_link: '/',
    app_store_link: '/',
  },
  headerLinks: [
    {
      href: Routes.quemSomos,
      label: 'Quem Somos',
    },
    {
      href: Routes.acoesSociais,
      label: 'Ações Sociais',
    },
    {
      href: Routes.politica,
      label: 'Política de Privacidade',
    },
    {
      href: Routes.termos,
      label: 'Termos e Condições',
    },
    {
      href: Routes.parceirosDeEntrega,
      label: 'Parceiros de Entregas',
    },
    {
      href: 'https://blog.qualidoc.com.br',
      label: 'Nosso Blog',
    },
  ],
  footer: {
    menus: [
      {
        title: 'text-explore',
        links: [
          {
            name: 'Shops',
            href: Routes.shops,
          },
          {
            name: 'Authors',
            href: Routes.authors,
          },
          {
            name: 'Flash Deals',
            href: Routes?.flashSale,
          },
          {
            name: 'Coupon',
            href: Routes.coupons,
          },
        ],
      },
      {
        title: 'text-customer-service',
        links: [
          {
            name: 'text-faq-help',
            href: Routes.help,
          },
          {
            name: 'Vendor Refund Policies',
            href: Routes.vendorRefundPolicies,
          },
          {
            name: 'Customer Refund Policies',
            href: Routes.customerRefundPolicies,
          },
        ],
      },
      {
        title: 'text-our-information',
        links: [
          {
            name: 'Manufacturers',
            href: Routes?.manufacturers,
          },
          {
            name: 'Privacy policies',
            href: Routes.politica,
          },
          {
            name: 'text-terms-condition',
            href: Routes.termos,
          },
          {
            name: 'text-contact-us',
            href: Routes.contactUs,
          },
        ],
      },
    ],
    payment_methods: [
      {
        img: '/payment/master.png',
        url: '/',
      },
      {
        img: '/payment/skrill.png',
        url: '/',
      },
      {
        img: '/payment/paypal.png',
        url: '/',
      },
      {
        img: '/payment/visa.png',
        url: '/',
      },
      {
        img: '/payment/discover.png',
        url: '/',
      },
    ],
  },
};
